<template>
  <div>
    <section class="section product-page product-detail-page">
      <div class="container">
        <div class="product__detail">
          <div class="product__image">
            <div class="product__thumbnails" v-if="product.pictures.length > 0">
              <button
                class="button-transparent up"
                @click="collectionPrev"
                v-if="stackCollection.length > 0"
              ></button>
              <transition-group
                :name="collectionTransitionName"
                :duration="{ enter: 1000, leave: 500 }"
              >
                <img
                  v-for="picture in currentCollection"
                  :key="picture.id"
                  class="product__thumbnail__item"
                  :class="{ active: mainImage == picture.file }"
                  v-lazy="picture.file"
                  @click="changeMainImage(picture)"
                />
              </transition-group>
              <button
                class="button-transparent down"
                @click="collectionNext"
                v-if="stackCollection.length > 0"
              ></button>
            </div>
            <!-- <img class="product__image__active" :src="mainImage" /> -->
            <div
              class="product__image__active"
              :style="{ 'background-image': `url('${mainImage}')` }"
            ></div>
          </div>
          <div class="product__image__sp">
            <button
              class="product__navigate prev"
              v-if="currentImageIndex > 0"
              @click="collectionPrevSp"
            ></button>
            <div class="product__image__list">
              <transition name="slide-fade">
                <img class="product__thumbnail__item" :src="currentImage" />
              </transition>
            </div>
            <button
              class="product__navigate next"
              v-if="currentImageIndex < currentCollection.length - 1"
              @click="collectionNextSp"
            ></button>
            <div class="product__image__footer">
              <div class="product-paging">
                <span
                  class="product-paging__page"
                  :class="{ active: index - 1 === currentImageIndex }"
                  v-for="index in currentCollection.length"
                  :key="index"
                ></span>
              </div>
            </div>
          </div>
          <div class="product__detail__info">
            <div class="product__name">{{ product.name }}</div>
            <span class="underline lg"></span>
            <div class="product__price">
              <div class="product__price__item">
                <div
                  :class="[
                    product.has_discount
                      ? 'product-item__price__old'
                      : 'product-item__price__current',
                  ]"
                >
                  {{ product.price_with_tax | priceFilter }}
                  <span class="product__price__suffix">税込</span>
                </div>
                <div
                  class="product-item__price__new"
                  v-if="product.has_discount"
                >
                  {{ product.new_price_with_tax | priceFilter }}
                  <span class="product__price__suffix">税込</span>
                </div>
              </div>
              <div class="product__action">
                <ProductFavorite
                  :loggedIn="loggedIn"
                  :product="product"
                ></ProductFavorite>
                <div class="product__memo">
                  <button class="memo__button" @click="toggleMemo">
                    <i class="fas fa-bell"></i>
                  </button>
                  <div class="memo" :class="{ active: isMemoActive }">
                    <p class="memo__header" @click="toggleMemo">Note</p>
                    <span>
                      お届け日・木札などは注文の際にご選択いただけます
                      <br />
                      <br />領収書の発行をご希望される方はアカウントを作成してください
                      <br />
                      <br />色物のお花（ピンク・赤リップ等）は時期・季節・天候状況により、納品までお時間を頂くケースがございます。予めご了承ください。
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="product__favorite">
              <ProductFavorite
                :loggedIn="loggedIn"
                :product="product"
              ></ProductFavorite>
            </div>
            <div class="product__status mb-20">
              <Stock :stock="product.stock"></Stock>
              <span class="product__status__split">|</span>
              <Rating
                :review-infos="product.review_infos"
                extra-class="lg"
              ></Rating>
            </div>
            <div class="product__description">
              <div class="product__description__content">
                {{ product.short_description }}
              </div>
            </div>

            <DeliveryInfo :areas="areas" :product-id="product.id" />

            <div class="product__description">
              <div class="product__colors">
                <!-- <span class="product__color" :class="product.color"></span> -->
                <strong>色:&nbsp;</strong>
                {{ product.color_i18n }}
              </div>
            </div>
            <div class="product__shipping">
              <h3 class="product__shipping__title">
                {{
                  product.is_plant
                    ? "東京23区内のみ送料無料 ※その他地域・納期により別途料金がかかります"
                    : "本州送料無料"
                }}
              </h3>
              <div class="product__shipping__body">
                <div class="product__shipping__body__item">
                  <p class="product__shipping__body__item">
                    請求書払いOK
                    <span>/ 会員特典</span>
                  </p>
                </div>
                <div class="product__shipping__body__item">
                  <p class="product__shipping__body__item">
                    ラッピング・立札無料
                  </p>
                </div>
                <div class="product__shipping__body__item">
                  <p class="product__shipping__body__item">
                    日本全国配送対応（一部商品よって条件が異なります）
                  </p>
                  <span>＊沖縄への配送はご相談させて頂く場合あり</span>
                  <span>＊冬季、寒冷地への配送が不可の場合あり</span>
                </div>
                <span class="underline"></span>
              </div>
            </div>
            <div class="product__quantity">
              <div class="product__quantity__control">
                <button
                  type="button"
                  class="product__quantity__button"
                  :disabled="quantity == 1"
                  @click="quantity -= 1"
                >
                  -
                </button>
                <input
                  type="number"
                  class="product__quantity__input"
                  v-model="quantity"
                />
                <button
                  type="button"
                  class="product__quantity__button"
                  @click="quantity += 1"
                >
                  +
                </button>
              </div>

              <button type="button" class="button" @click="addToCart">
                カートに入れる
              </button>
            </div>
            <span class="underline"></span>
            <ProductTags
              extra-class="large"
              :displayLabel="true"
              :product="product"
            ></ProductTags>
          </div>
        </div>
      </div>
    </section>

    <section class="section-description">
      <div class="container">
        <div class="product__description">
          <ul class="product__description__header">
            <li
              class="product__description__header__item"
              :class="{ active: activeTab == 'description' }"
              @click="activeTab = 'description'"
            >
              商品説明
            </li>

            <li
              class="product__description__header__item"
              :class="{ active: activeTab == 'data' }"
              @click="activeTab = 'data'"
            >
              商品データ
            </li>
            <li
              class="product__description__header__item"
              :class="{ active: activeTab == 'delivery' }"
              @click="activeTab = 'delivery'"
            >
              配送について
            </li>
            <li
              class="product__description__header__item"
              :class="{ active: activeTab == 'cost' }"
              @click="activeTab = 'cost'"
            >
              費用について
            </li>
          </ul>
          <div class="product__description__body">
            <p class="product__description__body__content">
              <span v-if="activeTab == 'description'">{{
                product.description
              }}</span>
              <ProductData
                v-if="activeTab == 'data'"
                :product="product"
              ></ProductData>
              <ProductDelivery
                v-if="activeTab == 'delivery'"
                :product="product"
              ></ProductDelivery>
              <ProductCost
                v-if="activeTab == 'cost'"
                :product="product"
              ></ProductCost>
            </p>
          </div>
        </div>
      </div>
      <ul class="product__description sp">
        <li class="product__description__item">
          <div class="product__description__item__header">
            <span class="product__description__item__header__title"
              >商品説明</span
            >
            <button
              class="product__description__item__header__trigger"
              @click="descriptionActive = !descriptionActive"
            >
              <i
                class="fas"
                :class="[descriptionActive ? 'fa-minus' : 'fa-plus']"
              ></i>
            </button>
          </div>
          <div
            class="product__description__body__content"
            v-if="descriptionActive"
          >
            {{ product.description }}
          </div>
        </li>
        <li class="product__description__item">
          <div class="product__description__item__header">
            <span class="product__description__item__header__title"
              >商品データ</span
            >
            <button
              class="product__description__item__header__trigger"
              @click="dataActive = !dataActive"
            >
              <i class="fas" :class="[dataActive ? 'fa-minus' : 'fa-plus']"></i>
            </button>
          </div>
          <div class="product__description__body__content" v-if="dataActive">
            <ProductData :product="product"></ProductData>
          </div>
        </li>
        <li class="product__description__item">
          <div class="product__description__item__header">
            <span class="product__description__item__header__title"
              >配送について</span
            >
            <button
              class="product__description__item__header__trigger"
              @click="deliveryActive = !deliveryActive"
            >
              <i
                class="fas"
                :class="[deliveryActive ? 'fa-minus' : 'fa-plus']"
              ></i>
            </button>
          </div>
          <div
            class="product__description__body__content"
            v-if="deliveryActive"
          >
            <ProductDelivery :product="product"></ProductDelivery>
          </div>
        </li>
        <li class="product__description__item">
          <div class="product__description__item__header">
            <span class="product__description__item__header__title"
              >費用について</span
            >
            <button
              class="product__description__item__header__trigger"
              @click="costActive = !costActive"
            >
              <i class="fas" :class="[costActive ? 'fa-minus' : 'fa-plus']"></i>
            </button>
          </div>
          <div class="product__description__body__content" v-if="costActive">
            <ProductCost :product="product"></ProductCost>
          </div>
        </li>
      </ul>
    </section>

    <section class="section">
      <ProductReviews
        :api-url="product.reviews_api_url"
        :review-infos="product.review_infos"
      ></ProductReviews>
    </section>
  </div>
</template>

<script>
import productMixins from "../../mixins/productMixins";

export default {
  components: {
    ProductData: () => import("./ProductParts/Data"),
    ProductDelivery: () => import("./ProductParts/Delivery"),
    ProductCost: () => import("./ProductParts/Cost"),
    Rating: () => import("./ProductParts/Rating"),
    ProductTags: () => import("./ProductParts/Tags"),
    Stock: () => import("./ProductParts/Stock"),
    ProductReviews: () => import("./ProductParts/Reviews"),
    DeliveryInfo: () => import("./DeliveryInfo.vue"),
    ProductFavorite: () => import("./ProductFavorite.vue"),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    loggedIn: {
      type: Boolean,
      required: true,
      default: false,
    },
    areas: {
      type: Object,
    },
  },
  data: function () {
    return {
      mainImage: null,
      activeTab: "description",
      rating: this.product.review_infos.rating,
      currentCollection: [],
      stackCollection: [],
      collectionTransitionName: "",
      quantity: 1,
      isMemoActive: false,
      descriptionActive: false,
      dataActive: false,
      deliveryActive: false,
      costActive: false,
      currentImageIndex: 0,
      currentImage: null,
    };
  },
  computed: {
    nearest_delivery_date: function () {
      return this.$dayjs(this.product.nearest_delivery_date).format(
        "MM月DD日 (ddd)"
      );
    },
  },
  mounted: function () {
    if (this.product.pictures.length > 0) {
      this.currentCollection = this.product.pictures.slice(0, 4);
      this.stackCollection = this._.difference(
        this.product.pictures,
        this.currentCollection
      );
      this.currentImage = this.currentCollection[this.currentImageIndex].file;
      this.mainImage = this.product.pictures[0].file;
    } else {
      this.currentImage = this.product.image_file;
      this.mainImage = this.product.image_file;
    }
  },
  mixins: [productMixins],
  methods: {
    changeMainImage: function (picture) {
      this.mainImage = picture.file;
    },
    collectionNextSp: function () {
      this.currentImageIndex += 1;
      this.currentImage = this.currentCollection[this.currentImageIndex].file;
    },
    collectionPrevSp: function () {
      this.currentImageIndex -= 1;
      this.currentImage = this.currentCollection[this.currentImageIndex].file;
    },
    collectionNext: function () {
      this.collectionTransitionName = "fadeUp";

      const removed = this.currentCollection.shift();
      const willAdd = this.stackCollection.shift();

      this.currentCollection.push(willAdd);
      this.stackCollection.push(removed);
      this.mainImage = this.currentCollection[0].file;
    },
    collectionPrev: function () {
      this.collectionTransitionName = "fadeDown";

      const removed = this.currentCollection.pop();
      const willAdd = this.stackCollection.pop();

      this.currentCollection.unshift(willAdd);
      this.stackCollection.unshift(removed);
      this.mainImage = this.currentCollection[0].file;
    },
    toggleMemo: function () {
      this.isMemoActive = !this.isMemoActive;
    },
  },
};
</script>

<style lang="scss" scoped>
.product__description__header__item {
  cursor: pointer;
}
</style>
